import { useProjectContext } from "@hooks/context/useProjectContext";
import { Box, Stack, Tab, Tabs } from "@mui/material";
import * as RouteHelper from "@utils/routes";
import { Link, matchPath, useLocation } from "react-router-dom";
interface ReportingPageTabsProps {
  reportId: string;
  reportDate: Date;
  setReportDate: (value: Date) => void;
}

function useRouteMatch(patterns: readonly string[]) {
  const { pathname } = useLocation();
  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }
  return null;
}

export const ReportingPageTabs = ({
  reportId,
}: ReportingPageTabsProps): JSX.Element => {
  const { selectedProject } = useProjectContext();

  const routesToMatch = [
    RouteHelper.labourHours(":projectId", ":reportId"),
    RouteHelper.socialProcurement(":projectId", ":reportId"),
  ];
  const routeMatch = useRouteMatch(routesToMatch);
  const currentTab = routeMatch?.pattern?.path;

  return (
    <Box>
      <Tabs value={currentTab}>
        <Tab
          label="Labour Hours"
          value={RouteHelper.labourHours(":projectId", ":reportId")}
          to={RouteHelper.labourHours(selectedProject.id, reportId)}
          component={Link}
        />
        <Tab
          label="Social Procurement"
          value={RouteHelper.socialProcurement(":projectId", ":reportId")}
          to={RouteHelper.socialProcurement(selectedProject.id, reportId)}
          component={Link}
        />
      </Tabs>
      <Stack
        spacing={2}
        direction="row"
        sx={{
          display: "flex !important",
          justifyContent: "right !important;",
        }}
      ></Stack>
    </Box>
  );
};
